import type {
  PasskeyAuthenticateOptionsResponse,
  PasskeyRegisterOptionsResponse,
} from '../types/auth.types';

export const base64UrlToArrayBuffer = (value: string): ArrayBuffer => {
  const base64 = value.replace(/-/g, '+').replace(/_/g, '/');
  const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=');
  const binary = atob(padded);
  const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0));
  return bytes.buffer.slice(bytes.byteOffset, bytes.byteOffset + bytes.byteLength);
};

export const toPublicKeyCredentialCreationOptions = (
  options: PasskeyRegisterOptionsResponse['options'],
): PublicKeyCredentialCreationOptions => ({
  ...options,
  challenge: base64UrlToArrayBuffer(options.challenge),
  user: {
    ...options.user,
    id: base64UrlToArrayBuffer(options.user.id),
  },
  excludeCredentials: options.excludeCredentials?.map((credential) => ({
    ...credential,
    id: base64UrlToArrayBuffer(credential.id),
  })),
});

export const toPublicKeyCredentialRequestOptions = (
  options: PasskeyAuthenticateOptionsResponse['options'],
): PublicKeyCredentialRequestOptions => ({
  ...options,
  challenge: base64UrlToArrayBuffer(options.challenge),
  allowCredentials: options.allowCredentials?.map((credential) => ({
    ...credential,
    id: base64UrlToArrayBuffer(credential.id),
  })),
});
